export default __webpack_public_path__ + "ee2e0cd439a49e8a6008afeedac2065d.png";